import { useEffect } from 'react';
import { Modal } from '@mui/material';
import { useAnalytics } from '@/hooks/useAnalytics';
import styles from './FlyerDetailsStatusModal.styles';
import { FloatingNotification } from '@/design-system';
import { VariantEnum } from '@/config/constants';

interface Props {
  trackId: string;
  title: string;
  variant: VariantEnum;
}

export const FlyerDetailsStatusModal: React.FC<Props> = ({ trackId, title, variant }) => {
  const { track } = useAnalytics();
  useEffect(() => {
    track({
      category: `${trackId}:non_active_flyer`,
      action: 'View Flyer',
      label: title,
      nonInteraction: true,
    });
  }, []);
  return (
    <Modal
      open
      disableAutoFocus
      disableScrollLock
      className={styles.container}
      BackdropProps={{
        style: { opacity: '0%' },
      }}
      sx={{ zIndex: 1 }}
      data-testid="modalContainer"
    >
      <FloatingNotification variant={variant}>{title}</FloatingNotification>
    </Modal>
  );
};
